import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';

const HTTP_ERROR_TOAST_KEY = 'http-errors';
const DEFAULT_ERROR_MESSAGE = 'Ein Fehler ist aufgetreten.';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const messageService = inject(MessageService);

    return next(req).pipe(
        catchError((error: unknown) => {
            const detail = getHttpErrorMessage(error);

            messageService.add({
                key: HTTP_ERROR_TOAST_KEY,
                severity: 'error',
                summary: 'Fehler',
                detail,
                life: 5000
            });

            return throwError(() => error);
        })
    );
};

function getHttpErrorMessage(error: unknown): string {
    if (!(error instanceof HttpErrorResponse)) {
        return DEFAULT_ERROR_MESSAGE;
    }

    if (error.status === 0) {
        return 'Der Server ist derzeit nicht erreichbar.';
    }

    return extractMessage(error.error) ?? `Fehler mit Fehlercode ${error.status} ist aufgetreten.`;
}

function extractMessage(payload: unknown): string | null {
    if (!payload || typeof payload !== 'object') {
        return null;
    }

    const message = (payload as Record<string, unknown>)['message'];
    if (typeof message === 'string' && message.trim()) {
        return message.trim();
    }

    return null;
}

export { HTTP_ERROR_TOAST_KEY };
